// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.interview-details-container {
    padding: 20px;
    max-width: 800px;
    margin: 0 auto;
    font-family: 'Inter', sans-serif;
  }
  
  .interview-details-container h2 {
    font-size: 1.8rem;
    color: #0047AB;
    margin-bottom: 20px;
  }
  
  .interview-details-container p {
    font-size: 1rem;
    color: #333;
    margin-bottom: 10px;
  }
  
  .interview-details-container pre {
    background-color: #f8f9fa;
    padding: 15px;
    border-radius: 5px;
    border: 1px solid #ddd;
    white-space: pre-wrap; /* Allows the text to wrap */
    word-wrap: break-word; /* Prevents long words from breaking the layout */
    font-size: 1rem;
    color: #333;
  }
  
  .error-message {
    color: #D8000C;
    background-color: #FFBABA;
    padding: 15px;
    border-radius: 5px;
    margin-bottom: 20px;
  }
  
  .interview-details-container p {
    margin-bottom: 10px;
  }

  .interview-details-container strong {
    font-weight: 600;
    color: #0047AB;
  }`, "",{"version":3,"sources":["webpack://./src/components/InterviewDetails.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,gCAAgC;EAClC;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,qBAAqB,EAAE,4BAA4B;IACnD,qBAAqB,EAAE,iDAAiD;IACxE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,cAAc;IACd,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB","sourcesContent":[".interview-details-container {\n    padding: 20px;\n    max-width: 800px;\n    margin: 0 auto;\n    font-family: 'Inter', sans-serif;\n  }\n  \n  .interview-details-container h2 {\n    font-size: 1.8rem;\n    color: #0047AB;\n    margin-bottom: 20px;\n  }\n  \n  .interview-details-container p {\n    font-size: 1rem;\n    color: #333;\n    margin-bottom: 10px;\n  }\n  \n  .interview-details-container pre {\n    background-color: #f8f9fa;\n    padding: 15px;\n    border-radius: 5px;\n    border: 1px solid #ddd;\n    white-space: pre-wrap; /* Allows the text to wrap */\n    word-wrap: break-word; /* Prevents long words from breaking the layout */\n    font-size: 1rem;\n    color: #333;\n  }\n  \n  .error-message {\n    color: #D8000C;\n    background-color: #FFBABA;\n    padding: 15px;\n    border-radius: 5px;\n    margin-bottom: 20px;\n  }\n  \n  .interview-details-container p {\n    margin-bottom: 10px;\n  }\n\n  .interview-details-container strong {\n    font-weight: 600;\n    color: #0047AB;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
